import { render, staticRenderFns } from "./GeneratorZeichnung.vue?vue&type=template&id=131964bc&scoped=true&"
import script from "./GeneratorZeichnung.vue?vue&type=script&lang=js&"
export * from "./GeneratorZeichnung.vue?vue&type=script&lang=js&"
import style0 from "./GeneratorZeichnung.vue?vue&type=style&index=0&id=131964bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131964bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
